// IAS overlay: no premium-plan promo indicators. Callers destructure
// `UpsellGem.New`, so we preserve that shape with null-returning components.
// Original wrapped `Object.assign(_UpsellGem, { New: UpsellGemNew })` around
// two `Icon` components rendering `data-testid="upsell-gem"`.
const IasHiddenGem = () => null;
export const UpsellGem = Object.assign(IasHiddenGem, {
  New: () => null,
});
